import React, { useState } from 'react';

const MapPinIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z" /><circle cx="12" cy="10" r="3" />
  </svg>
);
const PhoneIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.27 12 19.79 19.79 0 0 1 1.2 3.38 2 2 0 0 1 3.18 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.09 8.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
);
const MailIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22,6 12,13 2,6" />
  </svg>
);
const ClockIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
  </svg>
);
const SendIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="22" y1="2" x2="11" y2="13" /><polygon points="22 2 15 22 11 13 2 9 22 2" />
  </svg>
);
const ArrowIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" />
  </svg>
);

const INFO_BLOCKS = [
  {
    icon: <MapPinIcon />,
    title: 'Our Campus',
    lines: [
      'Jl. HBR Motik D6 No. 01, Kebon Kosong',
      'Kemayoran, Central Jakarta',
      'DKI Jakarta, Indonesia',
    ],
    link: {
      label: 'View on map',
      href: 'https://www.google.com/maps/place/Gandhi+Memorial+Intercontinental+School/@-6.151295,106.8522851,17z/data=!4m15!1m8!3m7!1s0x2e68e6302427de59:0x9d6b41147608c1e9!2sGandhi+Memorial+Intercontinental+School!8m2!3d-6.1513217!4d106.8523549!10e5!16s%2Fm%2F02vs_lz!3m5!1s0x2e68e6302427de59:0x9d6b41147608c1e9!8m2!3d-6.1513217!4d106.8523549!16s%2Fm%2F02vs_lz?hl=en-GB&entry=ttu&g_ep=EgoyMDI2MDkyMy4wIKXMDSoASAFQAw%3D%3D',
    },
  },
  {
    icon: <PhoneIcon />,
    title: 'Phone & Fax',
    lines: [
      'Main Office: +62 21 6586 5667',
      'Admissions: +62 811-1180-1448',
      'Fax: +62 21 789 1236',
    ],
  },
  {
    icon: <MailIcon />,
    title: 'Email Addresses',
    lines: [
      'General: admin@gmis.sch.id',
      'Admissions: admissions@gmis.sch.id',
      'Academics: admin@gmis.sch.id',
    ],
  },
  {
    icon: <ClockIcon />,
    title: 'Business Hours',
    lines: [
      'Mon – Thu: 7:30 AM – 4:00 PM',
      'Friday: 7:30 AM – 2:00 PM',
      'Saturday: By Appointment',
      'Sunday: Closed',
    ],
  },
];

const INQUIRY_TYPES = [
  'Admissions Inquiry',
  'Academic Programs',


  'Campus Tour',
  'Employment',
  'Partnerships',
  'General Inquiry',

  'Other',
];

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', phone: '', type: '', message: '' });
  const [sent, setSent] = useState(false);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    setSent(true);
  };

  return (
    <div className="w-full bg-white">

      {/* ── Hero Banner ── */}
      <div
        className="relative w-full flex items-center justify-center overflow-hidden bg-navy pt-[150px]"
        style={{ minHeight: '320px' }}
      >
        <div className="relative z-10 text-center px-6 py-16 max-w-3xl mx-auto">
          <div className="flex items-center justify-center gap-3 mb-4">
            <span className="text-gold text-[11px] font-bold tracking-[0.22em] uppercase">GMIS Jakarta</span>
          </div>
          <h1 className="m-0 text-white font-heading font-semibold text-[52px] leading-[1.1] tracking-[-0.015em]">
            Get in Touch with GMIS
          </h1>
          <p className="mt-5 text-white/75 text-[17px] leading-[1.7] max-w-2xl mx-auto">
            Connect with our dedicated team for admissions, academic inquiries, or to schedule a visit to our world-class campus.
          </p>
        </div>
      </div>

      {/* ── Main content ── */}
      <div className="max-w-[1440px] mx-auto px-[80px] xl:px-[120px] py-20 box-border">

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">

          {/* ── Left: Info blocks ── */}
          <div className="flex flex-col gap-6">
            {INFO_BLOCKS.map((block) => (
              <div
                key={block.title}
                className="group flex gap-5 p-6 bg-paper border border-line rounded-[4px] transition-all duration-300 hover:border-navy hover:shadow-lg"
              >
                {/* Icon circle */}
                <div
                  className="shrink-0 w-12 h-12 rounded-[3px] flex items-center justify-center text-white transition-all duration-300 group-hover:scale-105"
                  style={{ background: 'var(--navy)' }}
                >
                  {block.icon}
                </div>

                <div className="flex flex-col gap-1.5">
                  <div className="text-[11.5px] font-bold tracking-[0.14em] uppercase text-gold">{block.title}</div>
                  {block.lines.map((line) => (
                    <div key={line} className="text-[15px] leading-[1.6] text-ink/85">{line}</div>
                  ))}
                  {block.link && (
                    <a
                      href={block.link.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="mt-1 inline-flex items-center gap-2 text-navy text-[13.5px] font-semibold tracking-wide hover:text-gold transition-colors duration-200"
                    >
                      {block.link.label} <ArrowIcon />
                    </a>
                  )}
                </div>
              </div>
            ))}
          </div>

          {/* ── Right: Form ── */}
          <div
            className="relative rounded-[8px] overflow-hidden"
            style={{ boxShadow: 'rgb(14 36 62 / 18%) 0px 0px 2px' }}
          >

            {/* Form header */}
            <div className="px-10 py-9 relative overflow-hidden bg-navy">
              <div className="flex items-center gap-2 mb-3">
                <span className="text-gold text-[10.5px] font-bold tracking-[0.22em] uppercase">Enquiry Form</span>
              </div>
              <div className="text-white font-heading font-semibold text-[30px] leading-[1.15]">Send us a Message</div>
              <div className="text-white/60 text-[14px] mt-2 leading-[1.6]">
                We'll respond within <span className="text-gold font-semibold">24–48 hours</span> on business days.
              </div>


            </div>

            {/* Form body */}
            <div className="bg-white px-10 py-9">
              {sent ? (
                <div className="flex flex-col items-center text-center gap-5 py-10">
                  <div className="relative">
                    <div
                      className="w-20 h-20 rounded-full flex items-center justify-center bg-navy"
                    >
                      <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="20 6 9 17 4 12" />
                      </svg>
                    </div>
                    <div
                      className="absolute -inset-2 rounded-full opacity-20"
                      style={{ background: 'var(--navy)', animation: 'ping 1.5s cubic-bezier(0,0,0.2,1) infinite' }}
                    />
                  </div>
                  <div className="font-heading font-semibold text-[26px] text-navy">Message Received!</div>
                  <div className="text-muted text-[15px] leading-[1.7] max-w-[280px]">
                    Thank you for reaching out to GMIS. Our admissions team will be in touch with you very shortly.
                  </div>
                  <div className="flex gap-2 items-center bg-paper px-5 py-3 rounded-[4px] text-[13px] text-navy font-medium">
                    📧 Confirmation sent to <span className="font-bold">{form.email}</span>
                  </div>
                  <button
                    onClick={() => { setSent(false); setForm({ name: '', email: '', phone: '', type: '', message: '' }); }}
                    className="mt-2 px-7 py-3 rounded-[3px] border-2 border-navy text-navy text-[12.5px] font-bold tracking-wide hover:bg-navy hover:text-white transition-all duration-200"
                  >
                    Send Another Message
                  </button>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="flex flex-col gap-4">

                  {/* Row 1: Name + Email */}
                  <div className="grid grid-cols-2 gap-4">
                    <div className="flex flex-col gap-1.5">
                      <label className="text-[11.5px] font-bold tracking-[0.1em] uppercase text-navy/70">
                        Full Name <span className="text-gold">*</span>
                      </label>
                      <input
                        required
                        name="name"
                        value={form.name}
                        onChange={handleChange}
                        placeholder="Your full name"
                        className="h-[46px] px-4 bg-paper border-2 border-transparent rounded-[4px] text-[15px] text-ink placeholder:text-muted/50 focus:outline-none focus:border-navy focus:bg-white transition-all duration-200"
                      />
                    </div>
                    <div className="flex flex-col gap-1.5">
                      <label className="text-[11.5px] font-bold tracking-[0.1em] uppercase text-navy/70">
                        Email Address <span className="text-gold">*</span>
                      </label>
                      <input
                        required
                        type="email"
                        name="email"
                        value={form.email}
                        onChange={handleChange}
                        placeholder="your@email.com"
                        className="h-[46px] px-4 bg-paper border-2 border-transparent rounded-[4px] text-[15px] text-ink placeholder:text-muted/50 focus:outline-none focus:border-navy focus:bg-white transition-all duration-200"
                      />
                    </div>
                  </div>

                  {/* Row 2: Phone + Inquiry Type */}
                  <div className="grid grid-cols-2 gap-4">
                    <div className="flex flex-col gap-1.5">
                      <label className="text-[11.5px] font-bold tracking-[0.1em] uppercase text-navy/70">Phone Number</label>
                      <input
                        name="phone"
                        value={form.phone}
                        onChange={handleChange}
                        placeholder="+62 xxx xxxx xxxx"
                        className="h-[46px] px-4 bg-paper border-2 border-transparent rounded-[4px] text-[15px] text-ink placeholder:text-muted/50 focus:outline-none focus:border-navy focus:bg-white transition-all duration-200"
                      />
                    </div>
                    <div className="flex flex-col gap-1.5">
                      <label className="text-[11.5px] font-bold tracking-[0.1em] uppercase text-navy/70">
                        Inquiry Type <span className="text-gold">*</span>
                      </label>
                      <div className="relative">
                        <select
                          required
                          name="type"
                          value={form.type}
                          onChange={handleChange}
                          className="w-full h-[46px] pl-4 pr-10 bg-paper border-2 border-transparent rounded-[4px] text-[15px] text-ink focus:outline-none focus:border-navy focus:bg-white transition-all duration-200 appearance-none cursor-pointer"
                        >
                          <option value="">Select purpose</option>
                          {INQUIRY_TYPES.map((tp) => <option key={tp} value={tp}>{tp}</option>)}
                        </select>
                        <div className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-navy">
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="6 9 12 15 18 9" /></svg>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Message */}
                  <div className="flex flex-col gap-1.5">
                    <div className="flex items-center justify-between">
                      <label className="text-[11.5px] font-bold tracking-[0.1em] uppercase text-navy/70">
                        Your Message <span className="text-gold">*</span>
                      </label>
                      <span className={`text-[11px] font-medium tabular-nums ${form.message.length > 400 ? 'text-gold' : 'text-muted/60'}`}>
                        {form.message.length} / 500
                      </span>
                    </div>
                    <textarea
                      required
                      name="message"
                      value={form.message}
                      onChange={handleChange}
                      maxLength={500}
                      rows={5}
                      placeholder="Please tell us about your inquiry, the student's age/grade level, and any specific programs you're interested in..."
                      className="px-4 py-3.5 bg-paper border-2 border-transparent rounded-[4px] text-[15px] text-ink placeholder:text-muted/50 focus:outline-none focus:border-navy focus:bg-white transition-all duration-200 resize-none leading-[1.7]"
                    />
                  </div>

                  {/* Quick topic chips */}
                  <div className="flex flex-col gap-2">
                    <div className="text-[11px] font-bold tracking-[0.1em] uppercase text-navy/50">Quick topics</div>
                    <div className="flex flex-wrap gap-2">
                      {['IB Programme', 'Campus Tour', 'Scholarships', 'Fees & Tuition'].map((chip) => (
                        <button
                          key={chip}
                          type="button"
                          onClick={() => setForm(f => ({
                            ...f,
                            message: f.message ? f.message + ' ' + chip : chip,
                            type: chip === 'Admissions 2025' || chip === 'Campus Tour' ? 'Admissions' : chip === 'IB Programme' ? 'Academic Programs' : f.type,
                          }))}
                          className="px-3.5 py-1.5 rounded-full border border-line bg-paper text-[12px] text-navy font-medium hover:border-navy hover:bg-navy hover:text-white transition-all duration-200 cursor-pointer"
                        >
                          {chip}
                        </button>
                      ))}
                    </div>
                  </div>

                  {/* Divider */}
                  <div className="h-px bg-line" />

                  {/* Submit */}
                  <button
                    type="submit"
                    className="group h-[54px] flex items-center justify-center gap-3 rounded-[3px] bg-navy text-white text-[12.5px] font-bold tracking-widest uppercase transition-all duration-300 hover:shadow-xl hover:-translate-y-0.5"
                  >
                    <SendIcon />
                    Send Message
                    <svg className="transition-transform duration-300 group-hover:translate-x-1" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" />
                    </svg>
                  </button>

                  <div className="text-center text-[11.5px] text-muted/60">
                    By submitting, you agree to our <span className="text-navy font-medium cursor-pointer hover:underline">Privacy Policy</span>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>

        {/* ── Google Map ── */}
        <div className="mt-20">
          <div className="flex items-center gap-5 mb-8">
            <div>
              <div className="text-[11px] font-bold tracking-[0.18em] uppercase text-gold mb-1">Find Us</div>
              <h2 className="m-0 font-heading font-medium text-[34px] leading-[1.15] text-navy tracking-[-0.015em]">Campus Location</h2>
            </div>
            <a
              href="https://www.google.com/maps/place/Gandhi+Memorial+Intercontinental+School/@-6.151295,106.8522851,17z/data=!4m15!1m8!3m7!1s0x2e68e6302427de59:0x9d6b41147608c1e9!2sGandhi+Memorial+Intercontinental+School!8m2!3d-6.1513217!4d106.8523549!10e5!16s%2Fm%2F02vs_lz!3m5!1s0x2e68e6302427de59:0x9d6b41147608c1e9!8m2!3d-6.1513217!4d106.8523549!16s%2Fm%2F02vs_lz?hl=en-GB&entry=ttu&g_ep=EgoyMDI2MDkyMy4wIKXMDSoASAFQAw%3D%3D"
              target="_blank"
              rel="noopener noreferrer"
              className="ml-auto flex items-center gap-2 px-6 py-2.5 rounded-[3px] border-2 border-navy text-navy text-[13px] font-bold tracking-wide hover:bg-navy hover:text-white transition-colors duration-200 shrink-0"
            >
              Open in Google Maps <ArrowIcon />
            </a>
          </div>

          <div
            className="relative w-full overflow-hidden rounded-[4px]"
            style={{ height: '480px', border: '3px solid var(--line)' }}
          >
            <iframe
              title="GMIS Jakarta Campus Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3966.5398836399!2d106.8497802!3d-6.1513217!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e68e6302427de59%3A0x9d6b41147608c1e9!2sGandhi%20Memorial%20Intercontinental%20School!5e0!3m2!1sen!2sid!4v1696000000000!5m2!1sen!2sid"
              width="100%"
              height="100%"
              style={{ border: 0, display: 'block' }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
